// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MainFrame-LeftMenu-LeftMenu-module__backdrop--TF9o1 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1000;
  transition: opacity 0.3s ease;
  opacity: 1;
  pointer-events: all;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__box--m1asG {
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  height: 100%;
  width: 280px;
  overflow-y: auto;
  z-index: 1001;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuHeader--ML2Gn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 40px;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__logoBox--0wjjM {
  display: flex;
  align-items: baseline;
  gap: 12px;
  font-weight: 600;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__logo--RrgeU {
  color: #fc4807;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__label--To5ot {
  flex: 1;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItem--RZL7p {
  display: flex;
  flex-direction: row;
  padding: 0 24px;
  gap: 10px;
  height: 40px;
  align-items: center;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  cursor: pointer;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItem--RZL7p.src-components-MainFrame-LeftMenu-LeftMenu-module__active--OuJSn {
  border-right: 3px solid #fc4807;
  background: #fff1e6;
  color: #fc4807;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__menuItem--RZL7p:hover {
  background: #eee;
  color: #fc4807;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__subMenu--wx9rn {
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__subMenu--wx9rn .src-components-MainFrame-LeftMenu-LeftMenu-module__menuItem--RZL7p {
  padding-left: 48px;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__subMenu--wx9rn.src-components-MainFrame-LeftMenu-LeftMenu-module__collapsed--aMOx1 {
  max-height: 0;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__subMenu--wx9rn.src-components-MainFrame-LeftMenu-LeftMenu-module__expanded--H4bKa {
  max-height: 3000px;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__groupHeader--M8KIa {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__groupHeader--M8KIa .src-components-MainFrame-LeftMenu-LeftMenu-module__chevron--jUs_n {
  font-size: 10px;
  transition: transform 0.2s ease;
  color: #343a41;
}
.src-components-MainFrame-LeftMenu-LeftMenu-module__groupHeader--M8KIa .src-components-MainFrame-LeftMenu-LeftMenu-module__chevron--jUs_n.src-components-MainFrame-LeftMenu-LeftMenu-module__rotated--t7KEf {
  transform: rotate(-180deg);
}
/*# sourceMappingURL=LeftMenu.module.css.map */`, "",{"version":3,"sources":["webpack://./LeftMenu.module.less","webpack://./src/components/MainFrame/LeftMenu/LeftMenu.module.less"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,0BAAA;EACA,aAAA;EACA,6BAAA;EACA,UAAA;EACA,mBAAA;ACAF;ADGA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,+CAAA;ACDF;ADIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;ACFF;ADKA;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;ACHF;ADMA;EACE,cAAA;ACJF;ADOA;EACE,OAAA;ACLF;ADOA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EAEA,0BAAA;EAEA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,eAAA;ACRF;ADUE;EACE,+BAAA;EACA,mBAAA;EACA,cAAA;ACRJ;ADUE;EACE,gBAAA;EACA,cAAA;ACRJ;ADYA;EACE,gBAAA;EACA,uCAAA;ACVF;ADYE;EACE,kBAAA;ACVJ;ADaE;EACE,aAAA;ACXJ;ADcE;EACE,kBAAA;ACZJ;ADgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;ACdF;ADUA;EAOI,eAAA;EACA,+BAAA;EACA,cAAA;ACdJ;ADgBI;EACE,0BAAA;ACdN;AACA,8CAA8C","sourcesContent":["@import \"/src/variables.less\";\n.backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 1000;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n  pointer-events: all;\n}\n\n.box {\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: #fff;\n  height: 100%;\n  width: 280px;\n  overflow-y: auto;\n  z-index: 1001;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n}\n\n.menuHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  height: 40px;\n}\n\n.logoBox {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  font-weight: 600;\n}\n\n.logo {\n  color: @primary-orange;\n}\n\n.label {\n  flex: 1;\n}\n.menuItem {\n  display: flex;\n  flex-direction: row;\n  padding: 0 24px;\n  gap: 10px;\n  height: 40px;\n  align-items: center;\n\n  color: rgba(0, 0, 0, 0.85);\n  // font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n\n  cursor: pointer;\n\n  &.active {\n    border-right: 3px solid @primary-orange;\n    background: #fff1e6;\n    color: @primary-orange;\n  }\n  &:hover {\n    background: #eee;\n    color: @primary-orange;\n  }\n}\n\n.subMenu {\n  overflow: hidden;\n  transition: max-height 0.3s ease-in-out;\n\n  & .menuItem {\n    padding-left: 48px;\n  }\n\n  &.collapsed {\n    max-height: 0;\n  }\n\n  &.expanded {\n    max-height: 3000px; // Достаточно большое значение для любого количества элементов\n  }\n}\n\n.groupHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n\n  .chevron {\n    font-size: 10px;\n    transition: transform 0.2s ease;\n    color: @text-main;\n\n    &.rotated {\n      transform: rotate(-180deg);\n    }\n  }\n}\n",".backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  z-index: 1000;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n  pointer-events: all;\n}\n.box {\n  position: fixed;\n  left: 0;\n  top: 0;\n  background: #fff;\n  height: 100%;\n  width: 280px;\n  overflow-y: auto;\n  z-index: 1001;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);\n}\n.menuHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  height: 40px;\n}\n.logoBox {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  font-weight: 600;\n}\n.logo {\n  color: #fc4807;\n}\n.label {\n  flex: 1;\n}\n.menuItem {\n  display: flex;\n  flex-direction: row;\n  padding: 0 24px;\n  gap: 10px;\n  height: 40px;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  cursor: pointer;\n}\n.menuItem.active {\n  border-right: 3px solid #fc4807;\n  background: #fff1e6;\n  color: #fc4807;\n}\n.menuItem:hover {\n  background: #eee;\n  color: #fc4807;\n}\n.subMenu {\n  overflow: hidden;\n  transition: max-height 0.3s ease-in-out;\n}\n.subMenu .menuItem {\n  padding-left: 48px;\n}\n.subMenu.collapsed {\n  max-height: 0;\n}\n.subMenu.expanded {\n  max-height: 3000px;\n}\n.groupHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.groupHeader .chevron {\n  font-size: 10px;\n  transition: transform 0.2s ease;\n  color: #343a41;\n}\n.groupHeader .chevron.rotated {\n  transform: rotate(-180deg);\n}\n/*# sourceMappingURL=LeftMenu.module.css.map */"],"sourceRoot":""}]);
// Exports
export var backdrop = `src-components-MainFrame-LeftMenu-LeftMenu-module__backdrop--TF9o1`;
export var box = `src-components-MainFrame-LeftMenu-LeftMenu-module__box--m1asG`;
export var menuHeader = `src-components-MainFrame-LeftMenu-LeftMenu-module__menuHeader--ML2Gn`;
export var logoBox = `src-components-MainFrame-LeftMenu-LeftMenu-module__logoBox--0wjjM`;
export var logo = `src-components-MainFrame-LeftMenu-LeftMenu-module__logo--RrgeU`;
export var label = `src-components-MainFrame-LeftMenu-LeftMenu-module__label--To5ot`;
export var menuItem = `src-components-MainFrame-LeftMenu-LeftMenu-module__menuItem--RZL7p`;
export var active = `src-components-MainFrame-LeftMenu-LeftMenu-module__active--OuJSn`;
export var subMenu = `src-components-MainFrame-LeftMenu-LeftMenu-module__subMenu--wx9rn`;
export var collapsed = `src-components-MainFrame-LeftMenu-LeftMenu-module__collapsed--aMOx1`;
export var expanded = `src-components-MainFrame-LeftMenu-LeftMenu-module__expanded--H4bKa`;
export var groupHeader = `src-components-MainFrame-LeftMenu-LeftMenu-module__groupHeader--M8KIa`;
export var chevron = `src-components-MainFrame-LeftMenu-LeftMenu-module__chevron--jUs_n`;
export var rotated = `src-components-MainFrame-LeftMenu-LeftMenu-module__rotated--t7KEf`;
export default ___CSS_LOADER_EXPORT___;
